<template>
    <div class="gst-manage-booking d-flex flex-column">
        <div class="gst-manage-booking__content-wrapper d-flex flex-column">
            <DetailBanner class="gst-manage-booking__banner u-width-100">
                <template #title>
                    <b>{{ $t('title') }}</b>
                </template>
            </DetailBanner>

            <div class="gst-manage-booking__content content-max-width">
                <BookingContent />
            </div>
        </div>
        <div class="gst-manage-booking__support-section-wrapper d-flex flex-column mx-auto u-width-100 content-max-width">
            <PointsInformation v-if="userIsAuth" />
            <SupportSection class="gst-manage-booking__support-section justify-end" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DetailBanner from '@tenant/app/components/misc/DetailBanner.vue';
import SupportSection from '@tenant/app/modules/hotel/components/SupportSection.vue';
import PointsInformation from '@tenant/app/components/containerInfo/PointsInformation.vue';
import BookingContent from './TheManageBooking/BookingContent.vue';

export default {
    name: 'TheManageBooking',
    components: {
        BookingContent,
        DetailBanner,
        SupportSection,
        PointsInformation,
    },
    testIdOptions: {
        keyPrefix: 'manageBooking',
    },
    computed: {
        ...mapGetters({
            userIsAuth: 'user/isAuth',
        }),
    },
}
</script>

<style lang="scss">
@import '@scssMixins';
@import '@scssVariables';

.gst-manage-booking {
    justify-content: space-between;
    gap: theme-spacing(8);

    .gst-manage-booking__content-wrapper {
        gap: 17px;

        @include desktop-only {
            gap: 22px;
        }
    }

    @include desktop-only {
        min-height: 1411px;
    }
}

.gst-manage-booking__content {
    width: 100%;

    @include mobile-only {
        padding: theme-spacing(0, 4);
    }

    .gst-manage-booking__order-number {
        color: theme-color('quaternary');
        font-size: font-size('s');
        font-weight: font-weight('regular');
    }
}

.gst-manage-booking__support-section-wrapper {
    padding: theme-spacing(0, 4);
    gap: theme-spacing(8);

    @include desktop-only {
        padding: 0;
        gap: theme-spacing(6);
    }
}
</style>